"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuid = exports.shortId = exports.ShortUniqueId = void 0;
const short_unique_id_1 = __importDefault(require("short-unique-id"));
exports.ShortUniqueId = short_unique_id_1.default;
const createShortId = new short_unique_id_1.default({
    length: 16,
});
/**
 * Create a short ID with optional prefix.
 *
 * Length of the unique part of the ID is 16 characters.
 *
 * @param prefix - optional prefix to prepend to the generated id. Will automatically include _ separator between prefix and id.
 * @returns
 */
const shortId = (prefix) => {
    return `${prefix ? prefix + '_' : ''}${createShortId()}`;
};
exports.shortId = shortId;
/**
 * Get a UUID in 36 char format (including hyphens).
 *
 * Prefer this rather than installing another 3rd party dependency or using crypto API directly.
 */
const uuid = () => {
    return crypto.randomUUID();
};
exports.uuid = uuid;
